import React from 'react';
import { Box, Grid } from '@mui/material';
import CommonFilter from 'components/commonFilter/CommonFilter';
import CommonButton from 'components/commonButton/CommonButton';
import SearchBar from 'components/commonSearch/SearchBar';
import CommonDateRangePicker from 'components/commonDateRangePicker/CommonDateRangePicker';

const CommonSubHeader = (props) => {
  const {
    navigation,
    buttonName,
    filterStatus,
    dateRange,
    filter,
    defaultStatus,
    filterData,
    onFilterChange,
    onRestFilter,
    onSearchQuery,
    clearSearchQuery,
    onSelectDateRange,
    dateFrom,
    dateTo,
    search,
    showSearch
  } = props;

  return (
    <Grid container alignItems={'center'} justifyContent={'space-between'}>
      <Grid item xs={12} md={3}>
        {showSearch && 
        <SearchBar onSearchQuery={onSearchQuery} search={search} />}
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        lg={8}
        container
        justifyContent={'flex-end'}
        sx={{ marginTop: { xs: '20px', md: '0px' } }}
      >
        {dateRange && (
          <CommonDateRangePicker onSelectDateRange={onSelectDateRange} dateFrom={dateFrom} dateTo={dateTo} />
        )}
        {filterStatus && (
          <Box className="ml20">
            <CommonFilter
              filter={filter}
              defaultStatus={defaultStatus}
              filterdata={filterData}
              onFilterChange={onFilterChange}
              onRestFilter={onRestFilter}
            />
          </Box>
        )}
        {buttonName?.length > 0 && (
          <Box className="ml20">
            <CommonButton
              name={buttonName}
              btnClass={'btnMd btnYellow '}
              type="submit"
              iconPlace="front"
              iconType="+"
              onClick={navigation}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default CommonSubHeader;
